module.exports = __webpack_public_path__ + "static/media/baterias.18be63f0.png";